import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import styles from 'components/pages/common/EditField.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
export const MIN_PASSWORD_LENGTH = 10;
export const MAX_PASSWORD_LENGTH = 72;
export function PasswordField({ fieldName, value, onChange }) {
    const [showPassword, setShowPassword] = useState(false);
    const handleClick = () => {
        setShowPassword((prev) => !prev);
    };
    return (_jsx(TextField, { type: showPassword ? 'text' : 'password', label: fieldName, onChange: onChange, value: value, slotProps: {
            input: {
                endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { onClick: handleClick, edge: "end", size: 'small', children: showPassword ? _jsx(FontAwesomeIcon, { icon: faEye }) : _jsx(FontAwesomeIcon, { icon: faEyeSlash }) }) }))
            },
            htmlInput: {
                minLength: MIN_PASSWORD_LENGTH,
                maxLength: MAX_PASSWORD_LENGTH
            },
            inputLabel: {
                className: styles.inputLabel
            }
        } }));
}
